/**
 * Textos (en) de planta — OBR-148: proposta de lot FEFO i escaneig de l'etiqueta: namespace `planta.fefo`.
 * Tall propi: no es toca `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts) i les mateixes
 * variables. Vocabulari del sector: «Existències», mai «Stock».
 */

export const fefoEn = {
  'planta.fefo': {
    // ── Proposed batch (OT weighing and order picking) ───────────────────────────────────────
    suggestedChip: 'Suggested (FEFO)',
    scannedChip: 'Scanned',
    splitHint: 'The quantity is split across several batches, by expiry order. You can change it.',
    heldByOpenOrders: 'Already weighed on other open OTs: {{quantity}}',
    overdraw:
      'Batch {{lot}} only has {{available}}: {{over}} too much. You can split it with another batch or leave it as it is.',

    // ── Scanning a batch label ─────────────────────────────────────────────────────────────
    scanButton: 'Scan a batch',
    scanPickingTitle: 'Scan the batch label',
    scanPickingHint: 'Point the camera at the QR code of the batch you are about to serve',
    scanAccepted: 'Batch {{lot}} scanned and chosen.',
    scanNoStock:
      'Batch {{lot}} has no stock on this device. It is chosen anyway because you scanned it.',
    scanNoStockPicking:
      'Batch {{lot}} has no stock on this device: it could not be added. The rest is proposed by expiry order.',
    scanNotOffered:
      'Batch {{lot}} is not among the batches of this line on this device, so it was not chosen. Try again once it has synced.',
    scanUnknown: 'This code is not a batch this device knows.',
    scanWrongArticle:
      'Batch {{lot}} is “{{article}}”, not “{{expected}}”. It cannot be used here.',
    scanWrongArticleUnnamed:
      'Batch {{lot}} is another article, not “{{expected}}”. It cannot be used here.',
    scanWrongArticleGeneric:
      'Batch {{lot}} is “{{article}}”, not the article you are preparing. It cannot be used here.',
    scanWrongArticleGenericUnnamed:
      'Batch {{lot}} is another article, not the one you are preparing. It cannot be used here.',
    cascadeHint: 'The chosen batch does not have enough: the rest comes from other batches, by expiry order.',
  },
} as const;
